export default "__VITE_ASSET__DeuW65Yf__"